import { render } from "./MiddleArticle.vue?vue&type=template&id=47782e56"
import script from "./MiddleArticle.vue?vue&type=script&lang=js"
export * from "./MiddleArticle.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__